import React, { Component } from 'react';
/* eslint-disable */
import axios from 'axios';
import { MY_API_URL } from '../../Apanel/QueryMe';
var moment = require('moment');
import {
	Button,
	ButtonGroup,
	ButtonToolbar,
	Card,
	CardBody,
	Col,
	Badge,
	Table,
	Modal,
} from 'reactstrap';

import ProfileImage from '../../Apanel/ProfileImage';
const apiurl = MY_API_URL;
const dimgurl = apiurl + 'ava.png';
let seventhday = moment().subtract(6, 'days').format('ddd MM-DD-YYYY');
let sixthday = moment().subtract(5, 'days').format('ddd MM-DD-YYYY');
let fivethday = moment().subtract(4, 'days').format('ddd MM-DD-YYYY');
let fourthday = moment().subtract(3, 'days').format('ddd MM-DD-YYYY');
let threethday = moment().subtract(2, 'days').format('ddd MM-DD-YYYY');
let twothday = moment().subtract(1, 'days').format('ddd MM-DD-YYYY');
let today = moment().format('ddd MM-DD-YYYY');
let tendays = [
	today,
	twothday,
	threethday,
	fourthday,
	fivethday,
	sixthday,
	seventhday,
];
const initialstate = {
	image: dimgurl,
	allusers: [],
	showAlert: false,
	alertType: '',
	alertText: '',
	newrole: 'recruiter',
	email: '',
	domain: '',
	tendays: tendays,
	token: localStorage.token,
};
class ReportsSevenDaysPage extends Component {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };
	componentDidMount() {
		localStorage.setItem('viewrecruiter', '');
		localStorage.setItem('gotodash', 0);
		if (localStorage.profile_completed === '0') {
			localStorage.setItem('came_from', 'ReportsSevenDaysPage');
			this.props.history.push({
				pathname: '/profile',
				backTo: '/',
			});
		} else {
			this.handleGetSevendays(localStorage.token);
		}
	}

	handleGetSevendays = (token) => {
		let seventhday = moment().subtract(6, 'days').format('YYYY-MM-DD');
		let sixthday = moment().subtract(5, 'days').format('YYYY-MM-DD');
		let fivethday = moment().subtract(4, 'days').format('YYYY-MM-DD');
		let fourthday = moment().subtract(3, 'days').format('YYYY-MM-DD');
		let threethday = moment().subtract(2, 'days').format('YYYY-MM-DD');
		let twothday = moment().subtract(1, 'days').format('YYYY-MM-DD');
		let today = moment().format('YYYY-MM-DD');
		let tendays = [
			today,
			twothday,
			threethday,
			fourthday,
			fivethday,
			sixthday,
			seventhday,
		];
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			token: token,
			tendays: tendays,
			cemail: localStorage.by,
		};
		const getuurl = apiurl + 'compsevendays';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log('compsevendays: ', response.data);
				if (response.data.error) {
				} else {
					this.setState({
						allusers: [...response.data.allcomprecs],
					});
				}
			})
			.catch((error) => {
				// localStorage.clear();
				// this.props.history.push('/');
			});
	};

	render() {
		const {
			email,
			addUserModal,
			showObox,
			showCbox,
			showRbox,
			showAlert,
			alertType,
			alertText,
			newrole,
			domain,
		} = this.state;
		return (
			<Col md={12}>
				<Card>
					<CardBody>
						<div className="card__title">
							<h5 className="bold-text">Weekly Report</h5>
						</div>
						<Table responsive hover>
							<thead>
								<tr>
									<th>Recruiter</th>
									<th></th>
									{this.state.tendays.map((aday, index) => {
										return <th key={index}>{aday}</th>;
									})}
								</tr>
							</thead>
							<tbody>
								{this.state.allusers &&
									this.state.allusers.map((auser, index) => {
										let huser = auser.comprec;
										// let dayss = huser.senven;
										console.log(huser.seven);
										return (
											<tr key={index}>
												<td>
													<p>
														<ProfileImage
															clname="topbar__avatar-img"
															flpath={
																huser.image_url
																	? huser.image_url
																	: this.state.image
															}
														/>
														<b style={{ marginLeft: '5px' }}>{huser.name}</b>
													</p>
													<p>
														<b>Email: </b>
														{huser.email}
													</p>
													<p>
														<b>Mobile: </b>
														{huser.mobile}
													</p>
													<p>
														<b>Created: </b>
														{huser.createdon}
													</p>
												</td>
												<td>
													<b>Test Generated: </b>

													<br />
													<b>Test Sent: </b>

													<br />
													<b>Test Taken: </b>

													<br />
													<b>Logins: </b>

													<br />
												</td>
												{huser.seven.map((days, index) => {
													return (
														<td key={index} style={{ textAlign: 'center' }}>
															{days.ttest}
															<br />

															{days.tsent}
															<br />

															{days.ttaken}
															<br />
															{days.logged}
															<br />
														</td>
													);
												})}
											</tr>
										);
									})}
							</tbody>
						</Table>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default ReportsSevenDaysPage;
